type Listener = (balance: number) => void;

/**
 * The client's single source of truth for the local player's wallet balance during
 * play. Fed by the server's targeted `Balance` messages; the money HUD subscribes
 * to it. (The server is authoritative; this just mirrors it.)
 */
class BalanceStore {
  private balance = 0;
  private readonly listeners = new Set<Listener>();

  get(): number {
    return this.balance;
  }

  set(balance: number): void {
    this.balance = balance;
    for (const fn of this.listeners) fn(this.balance);
  }

  /** Subscribe; immediately invoked with the current value. Returns unsubscribe. */
  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.balance);
    return () => this.listeners.delete(fn);
  }
}

export const balanceStore = new BalanceStore();
